import { render, staticRenderFns } from "./WhatsappWebModal.vue?vue&type=template&id=f4d9011c&scoped=true"
import script from "./WhatsappWebModal.vue?vue&type=script&lang=js"
export * from "./WhatsappWebModal.vue?vue&type=script&lang=js"
import style0 from "./WhatsappWebModal.vue?vue&type=style&index=0&id=f4d9011c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d9011c",
  null
  
)

export default component.exports